var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topoguide-link-view"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('span',{staticClass:"is-size-2"},[_c(_vm.icon,{tag:"component"})],1),_vm._v(" "),_c('span',{staticClass:"is-size-4"},[_vm._v(_vm._s(_vm._f("uppercaseFirstLetter")(_vm.label)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }